import { useSyncExternalStore } from "react";

/** Public legal site language. Reviewers see English unless the visitor switches. */
export type LegalLang = "en" | "zh";

const KEY = "mt_legal_lang";
export const LEGAL_UPDATED = "2026-09-25";

function readLang(): LegalLang {
  try {
    const value = localStorage.getItem(KEY);
    if (value === "zh" || value === "en") return value;
  } catch {
    /* ignore */
  }
  return "en";
}

let current: LegalLang = readLang();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getLegalLang(): LegalLang {
  return current;
}

export function setLegalLang(lang: LegalLang) {
  current = lang;
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    /* ignore */
  }
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useLegalLang(): LegalLang {
  return useSyncExternalStore(subscribe, getLegalLang, () => "en");
}
